import { RunStates } from "./runStates";
import { BlankState, StateChanges } from "./stateChanges";
import router from "../router";
import $ from "jquery";
import _ from "lodash";

function gtag() {
  window.dataLayer.push(arguments);
}

const basicMutations = {
  [StateChanges.SOUNDPLAY_RUNNING](state) {
    state.soundplayState = RunStates.RUNNING;
  },
  [StateChanges.CHARUZIT_RUNNING](state) {
    state.charuzitApiState = RunStates.RUNNING;
  },
  [StateChanges.CHARUZIT_COMPLETE](state) {
    state.charuzitApiState = RunStates.COMPLETE;
  },
  [StateChanges.SET_SOUNDPLAY_RESULTS]: function (state, responseData) {
    state.soundplayResults = responseData;
    state.soundplayState = RunStates.COMPLETE;
  },
  [StateChanges.SET_CHARUZIT_RESULTS]: function (state, responseData) {
    state.charuzitApiResponse = responseData.results;
    state.charuzitMoreResults = responseData.fMoreMatches;
  },
  [StateChanges.SET_CHARUZIT_SINGLE_RESULTS]: function (state, responseData) {
    state.charuzitApiResponse = responseData;
  },
  [StateChanges.SET_CHARUZIT_BIBLE_RESULTS]: function (state, responseData) {
    state.charuzitBibleResponse = responseData.results;
    state.bibleMoreResults = responseData.fMoreMatches;
  },
  [StateChanges.SET_COMMON_RESULTS]: function (state, responseData) {
    state.commonResults = responseData.results;
    state.commonMoreResults = responseData.fMoreMatches;
  },
  [StateChanges.SET_TEXT_FOR_CHARUZIT_TEMP_API_CALL]: function (state, val) {
    state.tempTextForCharuzitApiCall = val;
  },
  [StateChanges.SET_NS_RESULTS]: function (state, responseData) {
    state.nsResults = responseData.results;
    state.noSuffixMoreResults = responseData.fMoreMatches;
  },
  [StateChanges.SET_LONG_RESULTS]: function (state, responseData) {
    state.longResults = responseData.results;
    state.longMoreResults = responseData.fMoreMatches;
  },
  [StateChanges.SET_FEM_RESULTS]: function (state, responseData) {
    state.femResults = responseData.results;
    state.femMoreResults = responseData.fMoreMatches;
  },
  [StateChanges.SET_ACCENT]: function (state, val) {
    state.preSubmissionOptions.accent = val;
  },
  [StateChanges.SET_DISPLAY_NAMES]: function (state, val) {
    state.preSubmissionOptions.displayNames = val;
  },
  [StateChanges.SET_CONSONANCE_MODE]: function (state, val) {
    state.preSubmissionOptions.displayConsonance = val;
  },
  [StateChanges.SET_MODEL]: function (state, val) {
    state.searchModel = val;
  },
  [StateChanges.SOUNDPLAY_FAILED]: function (state) {
    state.soundplayState = RunStates.FAILED;
  },
  [StateChanges.SOUNDPLAY_TIMED_OUT]: function (state) {
    state.soundplayState = RunStates.TIMED_OUT;
  },
  [StateChanges.CHARUZIT_FAILED]: function (state) {
    state.charuzitApiState = RunStates.FAILED;
  },
  [StateChanges.CHARUZIT_TIMED_OUT]: function (state) {
    state.charuzitApiState = RunStates.TIMED_OUT;
  },
  [StateChanges.SET_SOUNDPLAY_CALL_TEXT]: function (state, newText) {
    state.soundplayCallText = newText;
  },
  [StateChanges.SET_SEMANTICS]: function (state, newText) {
    state.semanticKeywordsArr.push(newText);
    gtag("event", "Semantic word added", {
      event_category: "selection",
    });
  },
  [StateChanges.INSERT_SEMANTIC_WORD]: function (state, obj) {
    state.semanticKeywordsArr.splice(obj.index, 0, obj.remove);
  },
  [StateChanges.REMOVE_SEMANTIC_ITEM]: function (state, index) {
    state.semanticKeywordsArr.splice(index, 1);
  },
  [StateChanges.SET_TAVNIT_PARAMS]: function (state, data) {
    state.tavnitSearchParams = data.itemsForApi;
    state.patternTokens = data.tokens;
  },
  [StateChanges.SET_VIEW_MODE]: function (state, val) {
    state.viewMode = val;
  },
  [StateChanges.SET_INCLUDE_FOREIGN]: function (state, val) {
    state.preSubmissionOptions.includeForeign = val;
  },
  [StateChanges.SET_INCLUDE_BIBLE]: function (state, val) {
    state.preSubmissionOptions.includeTanakh = val;
  },
  [StateChanges.SET_INCLUDE_NON_BASE]: function (state, val) {
    state.preSubmissionOptions.includeNonBase = val;
  },
  [StateChanges.SET_TEXT_FOR_CHARUZIT_API_CALL]: function (state, newText) {
    state.textForCharuzitApiCall = newText;
    if (newText !== "") {
      gtag("event", "Word Searched", {
        event_category: "selection",
        event_label: state.searchModel + " search: " + newText,
      });
    }
  },
  [StateChanges.SET_LET_SWAP]: function (state, newVal) {
    state.preSubmissionOptions.LetSwapSettings.consonentLetSwap = newVal;
  },
  [StateChanges.SET_VOC_SWAP]: function (state, newVal) {
    state.preSubmissionOptions.LetSwapSettings.vocalSwap = newVal;
  },
  [StateChanges.SET_RHYME_MODE]: function (state, newVal) {
    state.preSubmissionOptions.rhymeMode = newVal;
  },
  [StateChanges.SET_POS]: function (state, newIndex) {
    state.morph.posIndex = newIndex;
  },
  [StateChanges.SET_NUMBER]: function (state, newIndex) {
    state.morph.numberIndex = newIndex;
  },
  [StateChanges.SET_GENDER]: function (state, newIndex) {
    state.morph.genderIndex = newIndex;
  },
  [StateChanges.SET_PERSON]: function (state, newIndex) {
    state.morph.personIndex = newIndex;
  },
  [StateChanges.SET_TENSE]: function (state, newIndex) {
    state.morph.tenseIndex = newIndex;
  },
  [StateChanges.SET_STATUS]: function (state, newIndex) {
    state.morph.statusIndex = newIndex;
  },
  [StateChanges.SET_SUFFIX]: function (state, val) {
    state.morph.suffixIndex = val;
  },
  [StateChanges.SET_GENDER_SUFFIX]: function (state, newIndex) {
    state.morph.suffixGenderIndex = newIndex;
  },
  [StateChanges.SET_PERSON_SUFFIX]: function (state, newIndex) {
    state.morph.suffixPersonIndex = newIndex;
  },
  [StateChanges.SET_NUMBER_SUFFIX]: function (state, newIndex) {
    state.morph.suffixNumberIndex = newIndex;
  },
  [StateChanges.SET_MIN_SYL]: function (state, val) {
    state.preSubmissionOptions.minSyllable = val;
  },
  [StateChanges.SET_MAX_SYL]: function (state, val) {
    state.preSubmissionOptions.maxSyllable = val;
  },
  [StateChanges.SET_MAX_CONS]: function (state, val) {
    state.preSubmissionOptions.maxConsonant = val;
  },
  [StateChanges.SET_SEARCH_SORT]: function (state, val) {
    state.defaultSort = val;
  },
  [StateChanges.SET_ASSONANCE_MODE]: function (state, val) {
    state.preSubmissionOptions.displayAssonance = val;
  },
  [StateChanges.SET_XX_RESULTS]: function (state, responseData) {
    state.charuzitApiResponse = responseData[0].results;
    state.charuzitAssonanceResponse = responseData[1].results;
    state.charuzitConsonanceResponse = responseData[2].results;
    state.charuzitBibleResponse = responseData[3].results;
    state.bibleConsonanceResponse = responseData[13].results;
    state.bibleAssonanceResponse = responseData[8].results;
    state.commonResults = responseData[4].results;
    state.nsResults = responseData[5].results;
    state.longResults = responseData[6].results;
    state.femResults = responseData[7].results;
    state.AScommonResults = responseData[9].results;
    state.ASnsResults = responseData[10].results;
    state.ASlongResults = responseData[11].results;
    state.ASfemResults = responseData[12].results;
    state.CONcommonResults = responseData[14].results;
    state.CONcommonSemantic = responseData[14].results;
    state.CONnsResults = responseData[15].results;
    state.CONlongResults = responseData[16].results;
    state.CONfemResults = responseData[17].results;

    state.charuzitMoreResults = responseData[0].fMoreMatches;
    state.bibleMoreResults = responseData[3].fMoreMatches;
    state.commonMoreResults = responseData[4].fMoreMatches;
    state.noSuffixMoreResults = responseData[5].fMoreMatches;
    state.longMoreResults = responseData[6].fMoreMatches;
    state.femMoreResults = responseData[7].fMoreMatches;

    state.charuzitMoreResultsAS = responseData[1].fMoreMatches;
    state.bibleMoreResultsAS = responseData[8].fMoreMatches;
    state.commonMoreResultsAS = responseData[9].fMoreMatches;
    state.longMoreResultsAS = responseData[11].fMoreMatches;
    state.noSuffixMoreResultsAS = responseData[10].fMoreMatches;
    state.femMoreResultsAS = responseData[12].results;

    state.charuzitMoreResultsCON = responseData[2].fMoreMatches;
    state.bibleMoreResultsCON = responseData[13].fMoreMatches;
    state.commonMoreResultsCON = responseData[14].fMoreMatches;
    state.longMoreResultsCON = responseData[16].fMoreMatches;
    state.noSuffixMoreResultsCON = responseData[15].fMoreMatches;
    state.femMoreResultsCON = responseData[17].fMoreMatches;

    //state.charuzitApiState = RunStates.COMPLETE
  },
  [StateChanges.ADD_WORD_TO_LIST]: function (state, newText) {
    var index = state.personalWords.indexOf(newText);
    if (index < 0) {
      state.personalWords.push(newText);
      if (state.personalWords.length == 1) {
        document.getElementById("word-list").classList.add("opened");
      }
      $("#word-added-msg").fadeIn();
      setTimeout(() => {
        $("#word-added-msg").fadeOut();
      }, 2000);
      localStorage.SAVED_WORDS = state.personalWords;
      gtag("event", "Word Added", {
        event_category: "selection",
        event_label: newText,
      });
    }
  },
  [StateChanges.REMOVE_WORD_FROM_LIST]: function (state, text) {
    var index = state.personalWords.indexOf(text);
    if (index !== -1) {
      state.personalWords.splice(index, 1);
      $("#word-removed-msg").fadeIn();
      setTimeout(() => {
        $("#word-removed-msg").fadeOut();
      }, 2000);
      localStorage.SAVED_WORDS = state.personalWords;
    }
  },
  [StateChanges.REPLACE_LIST]: function (state, arr) {
    state.personalWords = arr;
    localStorage.SAVED_WORDS = state.personalWords;
    gtag("event", "Word List Added", {
      event_category: "selection",
    });
  },
  [StateChanges.SET_OVERVIEW]: function (state, val) {
    state.displayOverview = val;
  },
  [StateChanges.CLEAR_LIST]: function (state) {
    state.personalWords = [];
    localStorage.removeItem("SAVED_WORDS");
  },
  [StateChanges.SET_NO_RESULTS]: function (state, val) {
    state.noResults = val;
  },
  [StateChanges.CLEAR_RESULTS]: function (state) {
    //window.localStorage.removeItem('charuzit-search-state')
    Object.assign(state, JSON.parse(JSON.stringify(BlankState)));
    document.title = "חרוזית - חינמי מבית דיקטה";
    if (router.currentRoute.name !== "home") router.push({ name: "home" });
    router.replace({ query: {} });
  },
};

export default basicMutations;
